import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section footer-brand">
            <h2>ಮುಕ್ತಂಕಾರ ಟ್ರೇಡರ್ಸ್</h2>
            <p>ಮುಕ್ತಂಕಾರ ಟ್ರೇಡರ್ಸ್, ಕೋಟ್ಯಾಳ್ – ಇದು ಕೇವಲ ಒಂದು ಕಂಪನಿಯ ಹೆಸರು ಅಲ್ಲ, ಇದು ನಮ್ಮ ಕುಟುಂಬದ, ನಮ್ಮ ಊರಿನ, ಮತ್ತು ಸಾವಿರಾರು ರೈತರ ವಿಶ್ವಾಸದ ಚಿಹ್ನೆ.</p>
          </div>

          <div className="footer-section">
            <h3>ತ್ವರಿತ ಲಿಂಕ್‌ಗಳು</h3>
            <ul>
              <li><Link to="/about">ನಮ್ಮ ಬಗ್ಗೆ</Link></li>
              <li><Link to="/products">ಉತ್ಪನ್ನಗಳು</Link></li>
              <li><Link to="/contact">ಸಂಪರ್ಕಿಸಿ</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>ಸಂಪರ್ಕ ಮಾಹಿತಿ</h3>
            <ul className="contact-info">
              <li>
                <i className="fas fa-map-marker-alt"></i>
                <span>ಕೋಟ್ಯಾಳ್, ತಿಕೋಟ, ವಿಜಯಪುರ 586101</span>
              </li>
              <li>
                <i className="fas fa-phone"></i>
                <a href="tel:+919902671238">+91 99026 71238</a>
              </li>
              <li>
                <i className="fas fa-envelope"></i>
                <a href="mailto:info@muktankartraders.com">info@muktankartraders.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} ಮುಕ್ತಂಕಾರ ಟ್ರೇಡರ್ಸ್. Designed by Akshay Bellagi</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 